import { CartService, CartServiceModule } from '@b2b/common/services';
import angular from 'angular';

function OrderItemEventDirective() {
  OrderItemEventController.$inject = ['$scope', '$timeout', '$uibModal', 'CartService', 'ApiService'];
  function OrderItemEventController($scope, $timeout, $uibModal, CartService: CartService, ApiService) {
    $scope.orderItemEvent = {
      defaults: {
        editable: false,
        removable: true,
        removeLabel: 'Remove',
        editLabel: 'Edit',
      },
      options: {},
      removeModal: {},

      cartService: CartService,

      init: function () {
        $scope.$on('$destroy', $scope.$watch('options', this.onOptionsUpdate));
        $scope.$on('AppController::cart::refresh', angular.bind(this, this.getEventDetails));
        $scope.$on(
          '$destroy',
          $scope.$watch(
            'orderItemEvent.cartService.transactingMember.membership',
            angular.bind(this, this.onTransactingMembershipUpdate)
          )
        );
        $scope.$on(
          '$destroy',
          $scope.$watch(
            'orderItemEvent.cartService.transactingMember.membershipCategoryId',
            angular.bind(this, this.onTransactingMembershipCategoryUpdate)
          )
        );
        $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);

        if ($scope.model.eventId && !$scope.model.event) {
          this.getEventDetails();
        }

        this.normalizeDates();
      },

      normalizeDates: function () {
        if ($scope.model.event) {
          $scope.model.event = CartService.events.normalizeEventDate($scope.model.event);
        }
      },

      getEventDetails: function () {
        CartService.events.eventDetail($scope.model.eventId).then(this.eventDetailSuccess, this.eventDetailFail);
      },

      eventDetailSuccess: function (response) {
        const self = $scope.orderItemEvent;
        const event = response.data.payload;
        CartService.events.setEventDetail($scope.model.eventId, event);
        $scope.model.event = CartService.events.processEvent(event);

        $timeout(function () {
          $scope.$emit('OrderItem::Update');
        }, 10);

        CartService.events
          .eventMembershipDetail($scope.model.event.templateId)
          .then(self.eventMembershipDetailSuccess, self.eventMembershipDetailFail);
      },

      eventDetailFail: function () {},

      eventMembershipDetailSuccess: function (response) {
        CartService.events.setEventMembershipDetail($scope.model.eventId, response.data.payload);

        $timeout(function () {
          $scope.$emit('OrderItem::Update');
        }, 0);
      },

      eventMembershipDetailFail: function () {},

      getTicketCount: function () {
        return CartService.events.getEventTicketCount($scope.model.eventId);
      },

      getAddOnCount: function () {
        return CartService.events.getEventAddOnCount($scope.model.eventId);
      },

      getThumbnail: function () {
        const event = $scope.model.event;
        let result = '';

        if (
          event &&
          event.images instanceof Array &&
          event.images.length &&
          event.images[0] &&
          event.images[0].thumbnail
        ) {
          result = event.images[0].thumbnail;
        } else {
          result = '/assets/img/global/no-image-landscape.png';
        }

        return result;
      },

      remove: function () {
        const self = $scope.orderItemEvent;
        const eventId = $scope.model.eventId;

        self.removeModal = $uibModal.open({
          size: 'md',
          controller: 'ConfirmModalController',
          templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
          resolve: {
            modalTitle: function () {
              return 'Are you sure?';
            },
            okText: function () {
              return 'Remove';
            },
            modalMessage: function () {
              return 'Do you want to remove "' + $scope.model.event.name + '" from the cart?';
            },
          },
        });

        self.removeModal.result.then(
          function () {
            CartService.events.remove(eventId).then(
              function () {
                $scope.$emit('OrderItem::Remove');
              },
              function (response) {
                $scope.$emit('OrderItem::Remove::Error', response.data.error);
              }
            );
          },
          function () {
            // Do nothing
          }
        );
      },

      hasTickets: function () {
        const tickets = ($scope.model && $scope.model.tickets) || [];
        const result = tickets.filter(function (ticket) {
          return ticket && ticket.quantity;
        });

        return result.length;
      },

      hasAddOns: function () {
        const addOns = ($scope.model && $scope.model.addOns) || [];
        const result = addOns.filter(function (addOn) {
          return addOn && addOn.quantity;
        });

        return result.length;
      },

      hasItems: function () {
        return this.hasTickets() || this.hasAddOns();
      },

      onOptionsUpdate: function (n, o) {
        const self = $scope.orderItemEvent;

        if (n) {
          self.options = angular.extend(self.defaults, n);
        }
      },

      onDateFormatLoad: function () {
        $scope.orderItemEvent.normalizeDates();
      },

      onTransactingMembershipUpdate: function (n, o) {
        if (n !== o) {
          $scope.orderItemEvent.getEventDetails();
        }
      },

      onTransactingMembershipCategoryUpdate: function (n, o) {
        $scope.orderItemEvent.getEventDetails();
      },
    };

    $scope.orderItemEvent.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/order/item/event/event.tpl.html',
    scope: {
      model: '=',
      options: '=?',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: OrderItemEventController,
  };
}

export const OrderItemEventDirectiveModule = angular
  .module('acme.common.directive.order.item.event', ['ui.bootstrap', CartServiceModule, 'acme.common.service.api'])
  .directive('orderItemEvent', OrderItemEventDirective).name;
